import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.regexp.replace";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
import map from 'lodash/map';
import { stringify, parse } from 'qs';
import { LOCALES } from '~/const/i18n';
import { CATEGORY_INFIX, PRODUCT_INFIX } from '~/const/infix';
import { capitalize } from '~/helpers/user-helper';
const PRODUCTS_PER_PAGE = 40;

const buildEditorialCanonical = (base, path, page) => ({
  rel: 'canonical',
  href: "".concat(base).concat(path).concat(page ? "?page =".concat(page) : '')
});

const buildEditorialAlternates = function buildEditorialAlternates(base, type, slug) {
  let useAlias = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  let noType = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
  const currentSlug = slug ? "/".concat(slug) : '';
  let currentType = '';
  let trailingSlash = '';

  if (noType === false) {
    currentType = useAlias !== false ? "e/".concat(useAlias) : "e/".concat(type);
    trailingSlash = '/';
  }

  return map(LOCALES, locale => ({
    rel: 'alternate',
    hreflang: locale.iso ? locale.iso.toLowerCase() : '',
    href: "".concat(base, "/").concat(locale.market, "/").concat(locale.language).concat(trailingSlash).concat(currentType).concat(currentSlug)
  }));
};

const buildUrl = function buildUrl(urlbaseArray) {
  let queryString = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  let extension = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  const currentPath = urlbaseArray.join('/');
  const queryParams = queryString ? "?".concat(queryString) : '';
  const queryExtension = extension ? "".concat(extension) : '';
  return "".concat(currentPath).concat(queryExtension).concat(queryParams);
};

const buildCategoryNextLink = function buildCategoryNextLink(locale, base, alias, total, pagination) {
  let facet = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
  const predicate = total - pagination * PRODUCTS_PER_PAGE; // Current facet value is already a query param

  const facetParsed = parse(facet);
  const page = pagination + 1;
  const queryString = stringify(_objectSpread({}, predicate > 0 && {
    page
  }, predicate > 0 && facetParsed));
  return predicate > 0 ? {
    rel: 'next',
    href: buildUrl([base, locale.market, locale.language, CATEGORY_INFIX, alias], queryString)
  } : null;
};

const buildCategoryPrevLink = function buildCategoryPrevLink(locale, base, alias, pagination) {
  let facet = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
  // Current facet value is already a query param
  const facetParsed = parse(facet);
  const page = pagination - 1;
  const queryString = stringify(_objectSpread({}, pagination > 2 && {
    page
  }, facetParsed));
  return pagination > 1 ? {
    rel: 'prev',
    href: buildUrl([base, locale.market, locale.language, CATEGORY_INFIX, alias], queryString)
  } : null;
};

const buildCategoryCanonical = (locale, base, alias, page, facet) => {
  // Current facet value is already a query param
  const facetParsed = parse(facet);
  const queryString = stringify(_objectSpread({}, page > 1 && {
    page
  }, facetParsed));
  return {
    rel: 'canonical',
    href: buildUrl([base, locale.market, locale.language, CATEGORY_INFIX, alias], queryString)
  };
};

const buildMagazineLinks = (_ref) => {
  let {
    base,
    alias,
    type,
    page
  } = _ref;
  const queryString = stringify({
    page
  });
  return {
    rel: type,
    href: buildUrl([base, alias], queryString)
  };
};

const buildCategoryAlternates = function buildCategoryAlternates(base, aliases, hash, page) {
  let facet = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
  let hreflang = arguments.length > 5 ? arguments[5] : undefined;
  // Current facet value is already a query param
  const facetParsed = parse(facet);
  const queryString = stringify(_objectSpread({}, page > 1 && {
    page
  }, facetParsed));

  const markets = locale => hreflang && hreflang.length !== 0 ? hreflang.find(lang => lang.market.toUpperCase() === locale.market) : LOCALES;

  const locales = LOCALES.filter(locale => markets(locale));
  return map(locales, locale => ({
    rel: 'alternate',
    hreflang: locale.iso ? locale.iso.toLowerCase() : '',
    href: locale && locale.language && locale.market ? buildUrl([base, locale.market, locale.language, CATEGORY_INFIX, "".concat(aliases[locale.language.toLowerCase()], "-").concat(hash)], queryString) : ''
  }));
};

const buildProductAlternates = (isMarketplace, base, slugs, reference) => {
  const locales = isMarketplace ? [LOCALES.find(item => item.market === 'FR')] : LOCALES;
  return map(locales, locale => ({
    rel: 'alternate',
    hreflang: locale.iso ? locale.iso.toLowerCase() : '',
    href: locale && locale.language && locale.market ? buildUrl([base, locale.market, locale.language, PRODUCT_INFIX, "".concat(slugs[locale.language.toLowerCase()], "-").concat(reference)], '', '.htm') : ''
  }));
};

const buildUniqueClassName = (prefix, label) => "".concat(prefix, "-").concat(label.replace(/[ ,.]+/g, '-').toLowerCase());

const buildUniqueIdName = (prefix, label, id) => "".concat(prefix).concat(capitalize((label || '').split(/[\s,.]+/).map(capitalize).join(''))).concat(capitalize(id || ''));

export { buildEditorialCanonical, buildEditorialAlternates, buildCategoryNextLink, buildCategoryPrevLink, buildCategoryCanonical, buildCategoryAlternates, buildProductAlternates, buildUniqueClassName, buildMagazineLinks, buildUniqueIdName };